var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('module-page',_vm._b({},'module-page',_vm.pageParams,false),[(!_vm.loaded)?_c('screen-loading'):_vm._e(),_vm._v(" "),_c('iframe',{directives:[{name:"show",rawName:"v-show",value:(_vm.loaded),expression:"loaded"}],ref:"iframe",staticClass:"news__iframe",style:({ height: _vm.height }),attrs:{"scrolling":"yes","src":_vm.url},on:{"load":_vm.load}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d8394ee0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/news/Iframe.vue
// module id = null
// module chunks = 